import * as React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

type Props = {
    onPrimaryCtaClick: () => void;
    isCreating: boolean;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='Welcome to your SMS broadcasts page'
            subtitle='Any broadcasts that you draft, send, or schedule will appear here'
            detailTextBullets={[
                'Use a broadcast to make an announcement or inform viewers of something',
                'Craft your messages using merge fields to personalize the content for each of your target viewers',
                'Send messages to thousands of people at a time',
            ]}
            cta={
                <SaveButton
                    variant='primary'
                    size='big'
                    // @ts-expect-error
                    onClick={props.onPrimaryCtaClick}
                    isSaving={props.isCreating}
                    buttonText='Create new broadcast'
                    savingText='Creating broadcast'
                    successText='Broadcast created'
                />
            }
            icon={<Illustration src='sms-broadcast' width={275} />}
        />
    );
}
